import React from "react";
import injectSheet from "react-jss";
import StepHeaderIndicator from "./StepHeaderIndicator";
import StepHeaderLink from "./StepHeaderLink";
import StepHeaderTitle from "./StepHeaderTitle";
import ViewportPadding from "components/ViewportPadding";

const stepHeaderStyles = ({ theme }) => ({
  root: ({ active }) => ({
    color: theme.colors.tertiary1,
    backgroundColor: active ? theme.colors.primary5 : theme.colors.tertiary5,
    paddingTop: theme.padding.sm,
    paddingBottom: theme.padding.sm,
    borderBottom: `1px solid ${
      active ? theme.colors.tertiary3 : theme.colors.tertiary4
    }`
  }),
  inner: {
    display: "flex",
    alignItems: "center",
    justifyItems: "center",
    opacity: ({ disabled }) => (disabled ? "0.5" : 1)
  }
});

const StepHeader = ({ classes, children }) => {
  return (
    <div className={classes.root}>
      <ViewportPadding>
        <div className={classes.inner}>{children}</div>
      </ViewportPadding>
    </div>
  );
};

StepHeader.defaultProps = {
  disabled: false,
  visited: false
};

StepHeader.Title = StepHeaderTitle;
StepHeader.Indicator = StepHeaderIndicator;
StepHeader.Link = StepHeaderLink;

export default injectSheet(stepHeaderStyles)(StepHeader);
